/**
 * 주의(1단계) 알림음 — 짧은 「딩동」 두 음(약 0.5초, 2026-10-19 · 10-12 검증 V-31).
 *
 * 주의 경보는 지금까지 아무 소리도 내지 않았다(낭독은 경계 이상만). 관제실이 주의를 놓치지 않게 짧은 신호만 낸다 —
 * 사이렌(`alarmTone.ts`, 2.9초)과 헷갈리지 않도록 높이·길이를 다르게 하고 음성 안내는 붙이지 않는다.
 * 켜고 끄는 곳: 설정 > 음성 경보 방송 > 주의 알림음(기본 끔 — 관제 운영 소음은 사용자 결정).
 *
 * 파일 없이 Web Audio 로 만든다(설치본·오프라인에서도 같은 소리). 자동재생 차단·Web Audio 없음은 조용히 넘긴다 —
 * 화면 표시는 그대로 남는다. 짧은 시간 안에 여러 번 불려도 한 번만 울린다.
 */

type AudioCtxCtor = typeof AudioContext;

let ctx: AudioContext | null = null;
let lastAt = 0;
/** 이 안에 다시 불리면 겹쳐 울리지 않는다. */
const MIN_GAP_MS = 1_500;

function audioContext(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const Ctor = (window.AudioContext ??
    (window as unknown as { webkitAudioContext?: AudioCtxCtor }).webkitAudioContext) as AudioCtxCtor | undefined;
  if (!Ctor) return null;
  if (!ctx) {
    try {
      ctx = new Ctor();
    } catch {
      return null;
    }
  }
  return ctx;
}

function tone(ac: AudioContext, freq: number, start: number, dur: number, peak: number) {
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(freq, start);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(peak, start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(gain);
  gain.connect(ac.destination);
  osc.start(start);
  osc.stop(start + dur + 0.02);
}

/** 주의 알림음을 한 번 울린다. 실패해도 던지지 않는다. */
export function playCautionChime(): void {
  const now = Date.now();
  if (now - lastAt < MIN_GAP_MS) return;
  lastAt = now;
  const ac = audioContext();
  if (!ac) return;
  try {
    if (ac.state === "suspended") void ac.resume().catch(() => undefined);
    const t0 = ac.currentTime + 0.02;
    tone(ac, 1046.5, t0, 0.22, 0.22); // C6
    tone(ac, 784, t0 + 0.24, 0.3, 0.2); // G5
  } catch (e) {
    console.warn("[cautionChime] play failed", e);
  }
}
